// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"83571726","428":"140049c1","644":"f6396502","647":"63a8668c","988":"ceb0e190"}[chunkId] + ".chunk.css";
};